import { MatchCentreHeading } from '../../../../views';
import template from './index.jst';
import './index.styl';

export class MatchStatsHeading extends MatchCentreHeading {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre-table-heading player-profile';
	}

	initialize() {
		super.initialize();

		this.match_stat = this.options.match_stat;
		this.model.set('headings', this.match_stat.match_stats_headings);
	}
}

export default MatchStatsHeading;